import AddIcon from '@mui/icons-material/Add'
import RemoveIcon from '@mui/icons-material/Remove'
import { IconButton, Theme } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import React, { useEffect, useState } from 'react'
import useDebounce from '../../../hooks/useDebounce'

const useStyles = makeStyles((theme: Theme) => ({
  iconButton: {
    borderRadius: 0,
  },
}))

interface CartlineQtyWidgetProps {
  qty: number
  stockQty: number
  canEdit: boolean
  handleEditQty?(qty: number): void
}

const CartlineQtyWidget: React.FC<CartlineQtyWidgetProps> = ({ qty, stockQty, canEdit, handleEditQty }) => {
  const classes = useStyles()
  const [localQty, setLocalQty] = useState<string>(qty.toString())

  useEffect(() => {
    setLocalQty(qty.toString())
  }, [qty])

  const handleChangeQtyDebounced = useDebounce(handleEditQty, 1000)
  const handleChangeQty = (qty: string) => {
    setLocalQty(qty)
    if (qty !== '' && +qty > 0 && +qty <= stockQty) {
      handleChangeQtyDebounced(+qty)
    }
  }
  return (
    <div className='flex items-center justify-center w-100 h-30' style={{ border: canEdit ? 'solid 1px #ccc' : '' }}>
      {canEdit && (
        <IconButton
          className={classes.iconButton}
          size='small'
          onClick={() => handleChangeQty((+localQty - 1).toString())}
          disabled={localQty === '' || +localQty < 2}
          disableRipple
        >
          <RemoveIcon className='p-5' fontSize='inherit' style={{ width: 22, height: 22 }} />
        </IconButton>
      )}
      <span className='flex-1 appearance-none'>
        <input
          className='max-w-full w-40 text-center border-0'
          type='number'
          value={localQty}
          onChange={event => {
            handleChangeQty(event.target.value)
          }}
          disabled={!canEdit}
        />
      </span>
      {canEdit && (
        <IconButton
          className={classes.iconButton}
          size='small'
          onClick={() => handleChangeQty((+localQty + 1).toString())}
          disabled={localQty === '' || stockQty <= +localQty}
          disableRipple
        >
          <AddIcon className='p-2' fontSize='inherit' style={{ width: 22, height: 22 }} />
        </IconButton>
      )}
    </div>
  )
}

export default CartlineQtyWidget
